const statusCode = {
  "0": "审核中",
  "1": "已通过",
  "2": "已拒绝",
  "3": "草稿"
};

export const articleMixin = {
  data() {
    return {
      //文章状态============
      //所有状态
      APPROVE_STATUS_ALL: "-1",
      //待审核
      APPROVE_STATUS_NOT: "0",
      //已通过
      APPROVE_STATUS_AGREE: "1",
      //已拒绝
      APPROVE_STATUS_REFUSE: "2",
      //草稿数据
      APPROVE_STATUS_DRAFT: "3",

      //模块类型============
      ARTICLE_ALL_TYPE_CODE: "-1",
      //三角地
      ARTICLE_SJD_TYPE_CODE: "044-001",
      //大喇叭
      ARTICLE_DLB_TYPE_CODE: "044-002",
      //病例分享
      ARTICLE_CASE_SHARE_TYPE_CODE: "044-003",
      //病例讨论
      ARTICLE_CASE_DISCUSS_TYPE_CODE: "044-004",

      fileIconType: {
        ppt: "icon-file-ppt-fill",
        xls: "icon-file-excel-fill",
        xlsx: "icon-file-excel-fill",
        doc: "icon-file-word-fill",
        docx: "icon-file-word-fill",
        pdf: "icon-file-pdf-fill",
        jpg: "icon-tupian",
        png: "icon-tupian",
        gif: "icon-tupian",
        jpeg: "icon-tupian",
        txt: "icon-wenjian",
        unKnown: "icon-bg-unknownfile"
      },
      headerCellStyle: {
        background: "#E5F5F9",
        fontSize: "15px",
        color: "#353739"
      }
    };
  },

  methods: {
    computedShowEdit(row) {
      if (this.showDataType === "0" || this.showDataType === "2") {
        if (row.status !== this.APPROVE_STATUS_AGREE) {
          return row.createUserId === this.data.userId;
        } else {
          return false;
        }
      }
    },

    computedCaseShareShowEdit(row) {
      if (this.showDataType === "0" || this.showDataType === "2") {
        if (row.status !== this.APPROVE_STATUS_AGREE) {
          return row.createUserId === this.data.userId;
        } else if (row.status === this.APPROVE_STATUS_AGREE) {
          return row.createUserId === this.data.userId;
        } else {
          return false;
        }
      }
    },

    computedShowDelete(row) {
      //查看所有人的
      if (this.showDataType === "-1") {
        return false;
        //查看自己的
      } else if (this.showDataType === "0" || this.showDataType === "2") {
        return (this.data.useId = row.createUserId);
        //查看未审核的(管理员的)
      } else if (this.showDataType === "1") {
        return false;
      }
    },

    computedShowType(showDataType, flag) {
      return showDataType === flag ? "primary" : "cancel";
    },

    computedArticleUserNameTag(showDataType) {
      let userNameTag = "申请人";
      if (showDataType === "-1") {
        userNameTag = "发布人";
      } else if (showDataType === "0") {
        userNameTag = "审核人";
      } else if (showDataType === "1") {
        userNameTag = "申请人";
      }
      return userNameTag;
    },
    tableRowClassName({ row, rowIndex }) {
      return {
        "font-size": "16px"
      };
    }
  },

  filters: {
    fileIcon: function(arg, this_) {
      if (arg) {
        let type = arg.substring(arg.lastIndexOf(".") + 1);
        return this_.fileIconType[type] + " iconfont";
      }
      return "";
    },

    computedArticleStatus(status) {
      return statusCode[status];
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/mixins/articleMixin.js